/**
 * Copyright (c) 2016-present GlossGenius. All rights reserved.
 */

import React from 'react';

import Carousel from 'components/Carousel';
import { Check } from 'components/Icons/Check';
import { Location } from 'components/Icons/Location';
import { Payment } from 'components/Icons/Payment';

import { useBusiness } from 'hooks/business/useBusiness';
import { usePreferences } from 'hooks/preferences/usePreferences';

import s from './Banners.module.css';

const Banners = () => {
  const { address, showAddress } = useBusiness();
  const { doesHouseCalls } = usePreferences();

  const slides = [
    <div key="accepts_non_card_payments" className={s.banner}>
      <Payment />
      <span>Payments Accepted</span>
    </div>,
  ];

  if (showAddress) {
    slides.unshift(
      <div key="fixed_location_preference" className={s.banner}>
        <Location />
        <span>
          {address.split('\n').map((line) => (
            <span key={`${line}`} style={{ display: 'block' }}>
              {line}
            </span>
          ))}
        </span>
      </div>,
    );
  }
  if (doesHouseCalls) {
    slides.push(
      <div key="housecall_location_preference" className={s.banner}>
        <Check />
        <span>House Calls</span>
      </div>,
    );
  }

  if (slides.length === 1) {
    return <div className={s.root}>{slides}</div>;
  }
  return (
    <Carousel className={s.root} controlsClassName={s.controls}>
      {slides}
    </Carousel>
  );
};

export { Banners };
